import moment from "moment/moment";

/**
 * Фильтр даты
 * @param value Исходное значение
 * @param format Формат даты
 * @returns Форматированное значение
 */
export default function dateFilter(value: any, format: string = "DD-MM-YYYY") {
  moment.locale("ru");
  if (new Date(value).toString() == 'Invalid Date') return value;
  if (format === "date") format = "DD.MM.YYYY";
  else if (format === "datetime") format = "DD.MM.YYYY, HH:mm";
  else if (format === "daterev") format = "YYYY.MM.DD";
  else if (format === "time") format = "HH:mm";
  else if (format === "rudatafull") format = "DD MMMM YYYY";
  else if (format === "rudatafullTime") format = "DD MMMM YYYY, HH:mm";
  else if (format === "rudata") format = "DD MMMM";
  else if (format === "dateext") format = "DD.MM.YYYY";

  return moment(value).format(format);
}
